import * as ko from "knockout";
import entityBase from "entityBase";
import { attachment } from "./attachment";

export class attachment_wrapper extends entityBase {
  task_id: KnockoutObservable<string>;
  request_id: KnockoutObservable<string>;
  solution_id: KnockoutObservable<string>;
  attachment_id: KnockoutObservable<number>;
  attachment: KnockoutObservable<attachment>;
  is_selected: KnockoutObservable<boolean>;

  constructor(item: any) {
    super();
    this.task_id = ko.observable(item.task_id);
    this.solution_id = ko.observable(item?.solution_id);
    this.request_id = ko.observable(item.request_id).extend({ maxLength: 32 });
    this.attachment_id = ko.observable(item.attachment_id);
    this.attachment = ko.observable();
    if (item.attachment) {
      this.attachment(new attachment(item.attachment));
    }
    this.is_selected = ko.observable(item?.is_selected || false);
  }
}
